import React, {useEffect, useState} from 'react';
import { api } from "../../app/http-common";
import { TwitterTweetEmbed } from 'react-twitter-embed';
import './TwitterApiComponent.css';
import LazyLoadTweet from "./LazyLoadTweet";
import {useNavigate} from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedTweets } from '../../app/store';
import { setSelectedTweets } from './slice';

function TwitterApiComponent() {
  const [query, setQuery] = useState('');
  const [tweets, setTweets] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const selectedTweets = useSelector(selectSelectedTweets);


  const [searchParams, setSearchParams] = useState({
    allOfTheseWords: '',
    thisExactPhrase: '',
    anyOfTheseWords: '',
    noneOfTheseWords: '',
    hashtags: '',
    language: 'en',
    fromDate: '',
    toDate: ''
  });

    const navigate = useNavigate();
    useEffect(() => {
        if (!isAuthenticated()) {
            navigate('/login');
        }
    }, [navigate]);
    const isAuthenticated = () => {
        const token = localStorage.getItem('token');
        // Additional validation of token can be done here
        return !!token;
    };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchParams(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

//   useEffect(() => {
//         // Filter the URLs that are selected (value is true)
//         console.log('useEffect')
//         const selectedTweetsUrls = selectedTweets.map((id)=>'https://twitter.com/twitter/status/'+id)
//         console.log('useEffect',selectedTweetsUrls,selectedTweets)
//         localStorage.setItem('selectedTweetsUrls', JSON.stringify(selectedTweetsUrls));
//     }, [selectedTweets]);

  const toggleTweetSelection = (tweetId) => {
    dispatch(setSelectedTweets((currentSelectedTweets) =>
      currentSelectedTweets.includes(tweetId)
        ? currentSelectedTweets.filter(id => id !== tweetId)
        : [...currentSelectedTweets, tweetId]
    ));
  };

const handleSearch = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Start loading
    const results = await searchTweets(searchParams);
    setIsLoading(false); // End loading
    if (results.error) {
        alert(results.error);
    } else {
        setTweets(results);
    }
};

// Calculate 7 days ago date
  const today = new Date();
  const fiveDaysAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 5);
  const minDate = fiveDaysAgo.toISOString().split('T')[0]; // Format as YYYY-MM-DD
  const maxDate = today.toISOString().split('T')[0]; // Format as YYYY-MM-DD

  const languageOptions = [
  { code: 'en', name: 'English' },
      { code: 'ar', name: 'Arabic' },
      { code: 'iw', name: 'Hebrew' },
      { code: 'ru', name: 'Russian' },
       { code: 'uk', name: 'Ukrainian' },
  { code: 'es', name: 'Spanish' },
  { code: 'fr', name: 'French' },
  { code: 'de', name: 'German' },

  // Add more languages as needed
];



  return (
      <div className="form-container">
          <form onSubmit={handleSearch} style={{marginTop: '20px'}}>
              <div className="form-group">
                  <input
                      type="text"
                      name="allOfTheseWords"
                      placeholder="All of these words"
                      value={searchParams.allOfTheseWords}
                      onChange={handleChange}
                  />
              </div>
              <div className="form-group">
                  <input
                      type="text"
                      name="thisExactPhrase"
                      placeholder="This exact phrase"
                      value={searchParams.thisExactPhrase}
                      onChange={handleChange}
                  />
              </div>
              <div className="form-group">
                  <input
                      type="text"
                      name="anyOfTheseWords"
                      placeholder="Any of these words"
                      value={searchParams.anyOfTheseWords}
                      onChange={handleChange}
                  />
              </div>
              <div className="form-group">
                  <input
                      type="text"
                      name="noneOfTheseWords"
                      placeholder="None of these words"
                      value={searchParams.noneOfTheseWords}
                      onChange={handleChange}
                  />
              </div>
              <div className="form-group">
                  <input
                      type="text"
                      name="hashtags"
                      placeholder="Hashtags (separate with spaces)"
                      value={searchParams.hashtags}
                      onChange={handleChange}
                  />
              </div>
              <div className="form-group">
                  <label htmlFor="language">Language:</label>
                  <select
                      name="language"
                      value={searchParams.language}
                      onChange={handleChange}
                      id="language"
                  >
                      <option value="">Select Language</option>
                      {/* Optional: Add a default "select" option */}
                      {languageOptions.map((option) => (
                          <option key={option.code} value={option.code}>
                              {option.name}
                          </option>
                      ))}
                  </select>
              </div>
              <div className="form-group">
                  <label>
                      From date (YYYY-MM-DD):
                      <input
                          type="date"
                          name="fromDate"
                          value={searchParams.fromDate}
                          onChange={handleChange}
                          min={minDate} // Apply the minDate here
                          max={maxDate}
                      />
                  </label>
              </div>
              <button type="submit">Search</button>
          </form>
          {isLoading ? <p>Loading...</p> :
              <TweetsList tweets={tweets} onToggleSelection={toggleTweetSelection} selectedTweets={selectedTweets}/>}
      </div>
  );
}


function buildQuery(params) {
    let query = '';
    if (params.allOfTheseWords) query += `${params.allOfTheseWords} `;
    if (params.thisExactPhrase) query += `"${params.thisExactPhrase}" `;
    if (params.anyOfTheseWords) query += `${params.anyOfTheseWords.split(' ').join(' OR ')} `;
    if (params.noneOfTheseWords) query += `-${params.noneOfTheseWords} `;
    if (params.hashtags) query += `${params.hashtags.split(' ').map(tag => `#${tag}`).join(' ')} `;
    if (params.language) query += `lang:${params.language} `;
    //if (params.fromDate) query += `since:${params.fromDate} `;
   // if (params.toDate) query += `until:${params.toDate} `;
    return query.trim();
  }

// Dummy function, replace with your actual API call
async function searchTweets(searchParams) {
    // Here you would call your backend service that interacts with Twitter's API
    const query = buildQuery(searchParams);
    try {
        return await api.searchTweets({query,searchParams});
    } catch (error) {
        console.error('Error:', error);
    }
    return []; // Return tweets here
}

function TweetsList({tweets, onToggleSelection, selectedTweets}) {
    if (tweets.length === 0) {
        return <div>No tweets found</div>;
    }

    // Define the inline style for the tweet container
    const tweetContainerStyle = {
        //display: 'flex', // Make sure this is uncommented and applied
        alignItems: 'center', // Align items vertically in the center
        justifyContent: 'space-between', // Space between tweet and checkbox
        marginBottom: '10px', // Adds some space between each tweet
        // Ensure the container is wide enough
        width: '200%', // Use 100% of the parent container's width
    };


    return (
        <div>
            {tweets.map((tweet) => (
                <div key={tweet.id} style={tweetContainerStyle}>
                    <LazyLoadTweet tweetId={tweet.id}/>
                    <input
                        type="checkbox"
                        checked={selectedTweets.includes(tweet.id)}
                        onChange={() => onToggleSelection(tweet.id)}
                        style={{marginLeft: '10px'}} // Adds space between the tweet and the checkbox
                    />
                </div>
            ))}
        </div>
    );
}

export default TwitterApiComponent;
